(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('InitiativesStatusUpdateGovProcEditController', Controller);

    Controller.$inject = ['$scope', '$state', '$timeout', 'govNotificationDelay', 'notificationService', 'grcGovernanceProcessService', 'recomService'];
    function Controller($scope, $state, $timeout, govNotificationDelay, notificationService, grcGovernanceProcessService, recomService) {

        $scope.ctrlCtxt = {};
        $scope.govProcess.IsActive = true;

        grcGovernanceProcessService
            .getProcessTypes()
            .then(function (processTypes) {
                $scope.govProcess.GovernanceProcessTypeID =
                    _.find(processTypes, {Value: 'Initiative-Update-Status'}).GovernanceProcessTypeID;
            });

        grcGovernanceProcessService
            .getFiscalYears()
            .then(function (fiscalYears) {
                $scope.ctrlCtxt.fiscalYears = fiscalYears;
            });
    }
})();